import { render } from "./PersonTooltipComponent.vue?vue&type=template&id=6f791ffc&scoped=true"
import script from "./PersonTooltipComponent.vue?vue&type=script&lang=js"
export * from "./PersonTooltipComponent.vue?vue&type=script&lang=js"

import "./PersonTooltipComponent.vue?vue&type=style&index=0&id=6f791ffc&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f791ffc"]])

export default __exports__